import { makeAutoObservable, runInAction } from 'mobx';
import {
  IncomeChart,
  IncomeParams,
  IncomeRepotParam,
  Incomes,
  IncomReportData,
} from 'src/@types/Choqorak/MainTables/Income/Income';
import agent from 'src/api/agent';
export default class IncomeStore {
  openDialog = false;

  openFinancialPaymentsDialog = false;

  IncomeRegistry = new Map<number, Incomes>();

  editMode = false; //When click on edit button

  selectedIncome: Incomes | undefined = undefined;

  totalRecord: number = 0;

  IncomeReportResult: IncomReportData | undefined;

  selectedIncomeDetail: Incomes | undefined;

  IncomeChartData: IncomeChart | undefined;

  ID: any = localStorage.getItem('id');
  
  constructor() {
    makeAutoObservable(this);
  }

  get IncomeList() {
    return Array.from(this.IncomeRegistry.values());
  }

  setIncomeList = (Income: Incomes) => {
    this.IncomeRegistry.set(Income.incomeId!, Income);
  };

  //Pagination
  loadIncome = async (params: IncomeParams) => {
    // this.IncomeRegistry.clear();
    try {
      const result = await agent.Income.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setIncomeList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  IncomeSearch = async (params: IncomeParams) => {
    this.IncomeRegistry.clear();
    this.loadIncome(params);
  };

  getIncomeFromRegistry = (id: number) => {
    let Income = this.IncomeRegistry.get(id);
    if (Income) {
      this.editMode = true;
      this.selectedIncome = Income;
    }
  };

  clearSelectedIncome = () => {
    this.editMode = false;
    this.selectedIncome = undefined;
    this.selectedIncomeDetail = undefined;
  };

  deleteIncome = async (id: number, remark?: string) => {
    await agent.Income.delete(id, remark!);
    runInAction(() => {
      this.IncomeRegistry.delete(id);
      this.totalRecord--;
      this.setOpenCloseDialog();
    });
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  setOpenCloseFinancialPaymentDialog = () => (this.openFinancialPaymentsDialog = !this.openFinancialPaymentsDialog);

  createIncome = async (Income: Incomes) => {
    console.log(Income);
    await agent.Income.create(Income, Income.attachment);
    runInAction(() => {
      // this.loadIncome({ pageIndex: 0, pageSize: 5 });
      // this.clearSelectedIncome();
    });
  };

  updateIncome = async (Income: Incomes) => {
    await agent.Income.update(Income, Income.attachment);

    runInAction(() => {
      this.loadIncome({ pageIndex: 0, pageSize: 5 });
      this.IncomeRegistry.delete(Income.incomeId!);
      this.IncomeRegistry.set(Income.incomeId!, Income);
      this.clearSelectedIncome();
    });
  };

  loadIncomeDetail = async (id: number) => {
    try {
      const getIncomeDetail = await agent.Income.getDetail(id);
      runInAction(() => {
        this.selectedIncomeDetail = getIncomeDetail;
      });
    } catch (error) { }
  };

  loadIncomeReport = async (reportParams: IncomeRepotParam) => {
    // console.log(reportParams);
    const axiosResponse = await agent.Income.getIncomReport(reportParams);

    runInAction(() => {
      this.IncomeReportResult = axiosResponse.data;
    });
  };

  //#region RealTimeDashboard
  LoadIncomeChart = async () => {
    try {
      const dashboardData = await agent.Income.IncomeChartChart();
      runInAction(() => {
        if (dashboardData) {
          this.IncomeChartData = dashboardData.data;
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  //#endregion
}
